import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import jewellerybg from "../../assets/images/Home/header-dropdown-image.jpg";
import CollectionGridShop from "../Shop/CollectionGridShop";
import React, { useEffect, useState } from "react";

const NavMenu = React.memo(({ menuWhiteClass, sidebarMenu, categoryData, collectionData }) => {
  const location = useLocation();
  const [hoverState, setHoverState] = useState({
    collection: false,
    category: false,
  });

  const handleMouseEnter = (menu) => {
    setHoverState((prev) => ({ ...prev, [menu]: true }));
  };

  const handleMouseLeave = (menu) => {
    setHoverState((prev) => ({ ...prev, [menu]: false }));
  };

  useEffect(() => {
    setHoverState({ jewellery: false, collection: false });
  }, [location]);

  return (
    <div
      className={clsx(
        sidebarMenu
          ? "sidebar-menu"
          : `main-menu ${menuWhiteClass ? menuWhiteClass : ""}`
      )}
    >
      <nav>
        <ul>
          <li>
            <Link to="/AboutUs">About</Link>
          </li>
          <li
            className={hoverState.category ? "hovered" : ""}
            onMouseEnter={() => handleMouseEnter("category")}
            onMouseLeave={() => handleMouseLeave("category")}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Jewelry
            </Link>

            {categoryData?.Data && (
              <div className="menu_dropdown collection">
                <div className="menu_con">
                  {categoryData.Data.map((category, index) => (
                    <Link
                      to={`/category/${category.GatiCategoryId}`}
                      key={index}
                    >
                      {category.DesgGroupName}
                    </Link>
                  ))}
                </div>
                <CollectionGridShop />
              </div>
            )}
          </li>
          <li
            className={hoverState.collection ? "hovered" : ""}
            onMouseEnter={() => handleMouseEnter("collection")}
            onMouseLeave={() => handleMouseLeave("collection")}
          >
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Collection
            </Link>
            {collectionData?.Data && (
              <div className="menu_dropdown jewellery">
                <div className="menu_con">
                  {collectionData.Data.map((item, index) => (
                    <Link
                      to={`/collection/${item.GatiCategoryId}`}
                      key={index}
                      className="dropdown_link"
                    >
                      {item.DesgGroupName}
                    </Link>
                  ))}
                </div>
                <div className="img_con">
                  <img src={jewellerybg} alt="collection banner" />
                </div>
              </div>
            )}
          </li>
          <li>
            <Link to="/expertise">Expertise</Link>
          </li>
          {/* <li>
            <Link to="/media">Media</Link>
          </li> */}
          <li>
            <Link to="/ContactUs">Contact</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
});

NavMenu.propTypes = {
  menuWhiteClass: PropTypes.string,
  sidebarMenu: PropTypes.bool,
};

export default NavMenu;
